import React, { useState } from "react";
import {
  Select,
  Button,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import ExteriorImages from "./exteriorImages";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  DescriptionSection,
} from "../utils/AddSections";
import {
  FiImage,
  FiClock,
  FiDollarSign,
  FiPlus,
  FiSettings,
} from "react-icons/fi";
import { FaUtensils } from "react-icons/fa";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [type, setType] = useState<any>("african");
  const [openedDays, setOpenedDays] = useState<any>(
    "Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday"
  );
  const [openedAt, setOpenedAt] = useState<any>("00:00");
  const [closedAt, setClosedAt] = useState<any>("00:00");
  const [rating, setRating] = useState<any>(null);
  const [email, setEmail] = useState(null);
  const [payLink, setPayLink] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState(null);
  const [promoted, setPromoted] = useState<any>("no");
  const [restaurantStatus, setRestaurantStatus] = useState(1);
  const [description, setDescription] = useState(null);
  const [collection, setCollection] = useState<any[]>([]);
  const [menu, setMenu] = useState<any>(null);
  const [menu_id, setMenuId] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [exteriorImages, setExteriorImages] = useState<any[]>([]);
  const [showExtImages, setShowExtImages] = useState(false);
  const [expo, setExpo] = useState(0);
  const [pricing, setPricing] = useState<any[]>([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const restaurantRoutes = "/data/restaurant";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setType(null);
    setOpenedDays(
      "Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday"
    );
    setOpenedAt("00:00");
    setClosedAt("00:00");
    setRating(null);
    setEmail(null);
    setPayLink(null);
    setExpo(0);
    setPhoneNumber(null);
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setPromoted("no");
    setFormattedAddress(null);
    setRestaurantStatus(1);
    setDescription(null);
    setCollection([]);
    setMenu(null);
    setMenuId(null);
    setExteriorImages([]);
    setPricing([]);
  };

  const responses = (err: any, msg: any) => {
    setError(err);
    setLoading(false);
    setSuccess(!err);
    setErrorMessage(msg);
  };

  const addOneRestaurantHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      name: title,
      type: type,
      slug: title ? (title as any).toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      city_level: "level",
      opened_days: openedDays,
      opened_at: openedAt,
      closed_at: closedAt,
      rating: rating,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_ad: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: restaurantStatus,
      promoted: promoted,
      subdata: collection?.length > 0 ? collection : [],
      menu: menu
        ? {
            name: "...",
            category: "...",
            description: "...",
            thumbnail: menu,
            image_cdn_id: menu_id,
          }
        : null,
      expo: expo,
      exterior_images: exteriorImages?.filter((x: any) => x?.thumbnail !== null),
      pricing: pricing,
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.RESTAURANT,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={restaurantRoutes}
      eyebrow="DoSee Data • Restaurants"
      title="Add Restaurant"
      subtitle={`List a restaurant in ${entry_label || "this destination"}.`}
      icon={<FaUtensils className="h-5 w-5" />}
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <ModalDetails
            onClick={() => setShowModal(false)}
            showModal={showModal}
            collection={collection}
            setCollection={setCollection}
          />
          <ExteriorImages
            exteriorImages={exteriorImages}
            setExteriorImages={setExteriorImages}
            showModal={showExtImages}
            onClick={() => setShowExtImages(false)}
          />
        </>
      }
      loading={loading}
      submitLabel="Add Restaurant"
      onSubmit={addOneRestaurantHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Profile Image & Menu"
        hint="Restaurant cover, plus an optional menu PDF/image."
        icon={<FiImage className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <p className="mb-2 text-xs font-semibold text-gray-600">
              Profile Image
            </p>
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={image_kit_folder(country_name, FOLDERS.RESTAURANTS)}
            />
          </div>
          <div>
            <p className="mb-2 text-xs font-semibold text-gray-600">Menu</p>
            <ImageKitUpload
              thumbnail={menu}
              thumbnailId={menu_id}
              setThumbnail={setMenu}
              setThumbnailId={setMenuId}
              folder={image_kit_folder(country_name, FOLDERS.RESTAURANTS)}
            />
          </div>
        </div>
      </AddSection>

      <AddSection title="Restaurant Details" hint="Name, cuisine type and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "type",
              title: "Cuisine Type",
              type: "text",
              option: [
                "african",
                "american",
                "south american",
                "european",
                "asian",
                "oceanian",
                "intercontinental",
              ],
              onChange: (e: any) => {
                setType(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Hours"
        hint="Operating days and hours."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "opened_days",
              title: "Open Days",
              type: "text",
              value: openedDays || "",
              onChange: (e: any) => {
                setOpenedDays(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "opened_at",
              title: "Opened At",
              type: "time",
              value: openedAt || "",
              onChange: (e: any) => {
                setOpenedAt(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "closed_at",
              title: "Closed At",
              type: "time",
              value: closedAt || "",
              onChange: (e: any) => {
                setClosedAt(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "rating",
              title: "Rating",
              type: "text",
              value: rating || "",
              onChange: (e: any) => {
                setRating(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <AddSection
        title="Visibility"
        hint="Where this entry appears across the site."
        icon={<FiSettings className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <Select
            props={{
              id: "restaurant_status",
              title: "Status",
              required: true,
              option: ["visible", "invisible"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setRestaurantStatus(1);
                else setRestaurantStatus(0);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "promoted",
              title: "Promoted",
              option: ["no", "yes"],
              onChange: (e: any) => {
                setPromoted(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "gallery",
              title: "Show in Gallery",
              option: ["no", "yes"],
              onChange: (e: any) => {
                const choice = e.target.value;
                setExpo(choice === "no" ? 0 : 1);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Galleries & Extras"
        hint="Optional interior/exterior photos and menu items."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <div className="flex flex-wrap items-center gap-3">
          <Button
            props={{
              type: "button",
              title: "Add Inter. / Exter. Images",
              category: "default",
              action: "add",
              onClick: () => setShowExtImages(true),
            }}
          />
          <Button
            props={{
              type: "button",
              title: "Add More Details",
              category: "default",
              action: "add",
              onClick: () => setShowModal(true),
            }}
          />
        </div>
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Add;
